import { vulnTrendChartConstants } from './cs-vuln-trend-chart-constants'

export function csVulnTrendChartTooltip($compile, $translate) {
  'ngInject'

  return {
    restrict: 'A',
    scope: {
      template: '@',
      count: '@?',
      countSign: '@?',
      text: '@?',
      reportType: '@?',
      timestamp: '@?',
      statusBreakdown: '@?',
      displayPosition: '@',
      displayClass: '@'
    },
    link: ($scope, elem) => link($scope, elem, $compile, $translate)
  }
}

export function link($scope, elem, $compile, $translate) {
  if (!elem.scope().tooltipLoaded) {
    $scope.tooltipLoaded = true
    if ($scope.statusBreakdown) {
      const parsed = parseStatusBreakdown($scope.statusBreakdown, $translate)
      $scope.statusBreakdownParsed = parsed
    }
    elem.attr('uib-tooltip-template', $scope.template)
    elem.attr('tooltip-placement', 'auto ' + $scope.displayPosition)
    elem.attr('tooltip-append-to-body', true)
    elem.attr('tooltip-class', $scope.displayClass)
    $compile(elem)($scope)
  }
}

export function parseStatusBreakdown(str, $translate) {
  const labels = {
    'Auto Remediated': $translate.instant(
      'title_vulnerabilityStatusAutoRemediated'
    ),
    Reported: $translate.instant('title_vulnerabilityStatusReported'),
    Suspicious: $translate.instant('title_vulnerabilityStatusSuspicious'),
    Confirmed: $translate.instant('title_vulnerabilityStatusConfirmed'),
    'Not A Problem': $translate.instant('title_vulnerabilityStatusNotProblem'),
    Remediated: $translate.instant('title_vulnerabilityStatusRemediated'),
    Fixed: $translate.instant('title_vulnerabilityStatusFixed')
  }
  const pieces = str.split(',')
  const final = Array()
  pieces.forEach((piece) => {
    const subPieces = piece.split(vulnTrendChartConstants.DELIM)
    final.push({
      count: subPieces[0],
      status: labels[subPieces[1]] || subPieces[1]
    })
  })
  return final
}
